export const downloadFile = (url: string | null, name: string | null) => {
  if (!url || !name) {
    return;
  }
  const a = document.createElement('a');
  a.href = url;
  a.setAttribute('download', name);
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};
